<template>

  <div width="240" height="240">
    <a-modal v-model="visible" :maskClosable="false" :confirmLoading="loading" @cancel="cancel" :footer="null">
      <div slot="title" style="text-align: center;color:#75869a">{{"会员充值续费"}}</div>
      <div slot="title" style="text-align: left; margin-left: 5px; font-size:10px; color:#75869a;">
        交易订单：{{form.order_no}}
      </div>
      <div slot="title" style="text-align: left; margin-left: 5px; font-size:10px; color:#75869a">购买物品：客户数量≤<span
          style="text-align: center;font-size:13px;color:#ff4d4f"> {{form.custom_quantity}} </span>条, 供应商数量≤<span
          style="text-align: center;font-size:13px;color:#ff4d4f"> {{form.supplier_quantity}} </span>条
        采购记录数量≤<span style="text-align: center;font-size:13px;color:#ff4d4f"> {{form.purchase_record_quantity}}
        </span>条,
        销售记录数量≤<span style="text-align: center;font-size:13px;color:#ff4d4f"> {{form.orders_record_quantity}} </span>条,
        入库记录数量≤<span style="text-align: center;font-size:13px;color:#ff4d4f"> {{form.instock_record_quantity}} </span>条,
        出库记录数量≤<span style="text-align: center;font-size:13px;color:#ff4d4f"> {{form.outstock_record_quantity}}
        </span>条,
        盘点记录数量≤<span style="text-align: center;font-size:13px;color:#ff4d4f"> {{form.inventory_quantity}} </span>条,
        付款数量≤<span style="text-align: center;font-size:13px;color:#ff4d4f"> {{form.payment_quantity}} </span>条,
        收款数量≤<span style="text-align: center;font-size:13px;color:#ff4d4f"> {{form.collection_quantity}} </span>条,
        日常收支数量≤<span style="text-align: center;font-size:13px;color:#ff4d4f"> {{form.daily_income_expend_quantity}}
        </span>条,
        账户转账数量≤<span style="text-align: center;font-size:13px;color:#ff4d4f"> {{form.account_transfer_quantity}}
        </span>条会员套餐</div>
      <div slot="title" style="text-align: left; margin-left: 5px; font-size:10px; color:#75869a;">
        备注：<span style="text-align: center;font-size:10px;color:#ff4d4f">升级套餐剩余半年以上折算成新套餐200天,半年以下折算成新套餐100天 </span>
      </div>
      <div>
        <div slot="title" style="text-align: center;font-size:13px;color:#75869a">充值金额：<span
            style="text-align: center;font-size:20px;color:#ff4d4f">{{form.sale_price}}</span> 元
        </div>
        <a-form-model-item style="text-align: center;margin-top: 13px;">
          <img :src="form.imgUrl" width="150" height="150" style="text-align: left; " />
        </a-form-model-item>
        <div slot=" title" style="text-align: center;font-size:13px;color:#75869a">使用<span
            style="font-size:13px;color:#ff4d4f">微信</span>完成支付
        </div>

      </div>
    </a-modal>
  </div>
</template>

<script>
import { orderResult } from '@/api/recharge'
export default {
  name: "FormModal",
  props: ["visible", "form"],
  model: { prop: "visible", event: "cancel" },
  data () {
    return {
      loading: false,
      count: 0,
      timer: null,
      //order_no: "order_no",
      //recharge_amt: 200,
      //imgUrl: form.imgUrl, 

    };

  },
  methods: {
    initialize () {
      this.clockTime();
    },
    clockTime () {
      //if (this.form.order_no) {
      this.timer = setInterval(async () => {
        this.getResult()
        if (this.count > 20) {
          this.$emit("list")
          //console.log("count次数大于20");
          clearInterval(this.timer);//清除定时器            
          this.count = 0;
        }
      }, 3000);
      //}
    },
    getResult () {
      //查询支付结果,开启定时器每隔一段时间（这里指定1秒轮询一次）询问支付结果
      let result = {
        order_no: this.form.order_no,
        custom_quantity: this.form.custom_quantity,
        supplier_quantity: this.form.supplier_quantity,
        purchase_record_quantity: this.form.purchase_record_quantity,
        orders_record_quantity: this.form.orders_record_quantity,
        instock_record_quantity: this.form.instock_record_quantity,
        outstock_record_quantity: this.form.outstock_record_quantity,
        inventory_quantity: this.form.inventory_quantity,
        payment_quantity: this.form.payment_quantity,
        collection_quantity: this.form.collection_quantity,
        daily_income_expend_quantity: this.form.daily_income_expend_quantity,
        account_transfer_quantity: this.form.account_transfer_quantity,
      };
      console.log(result)
      orderResult(result).then(data => {
        console.log(data)
        //返回数据当中：code=0代表支付成功 3是支付中 其他支付失败 其他表示未支付成功
        if (data.res.code == 0) {
          this.$message.success("支付成功.");
          this.count = 21;
          this.cancel();
        } else if (data.res.code == 3) {

        } else {
          this.$message.error("支付失败.");
          this.count = 21;
        }
      })
    },
    cancel () {
      this.$emit("cancel", false);
    },
  },
  mounted () {
    this.initialize();
  },
}


</script>

<style scoped></style>
